import Vue from 'vue'
import Element from 'element-ui'
import './custom-theme/index.css'
import locale from 'element-ui/lib/locale/lang/pt-br'

Vue.use(Element, { locale })
